<template>
  <!-- <el-container> -->
    <el-row>
      <el-col :lg="{span:'17'}" :md="{span:'16'}" :sm="{span:'15'}" :xs="{span:'24'}" >
        <img :src="image_auth" class="image-auth"/>
      </el-col>

      <el-col :lg="{span:'6', offset: '1'}" :md="{span:'7', offset: '1'}" :sm="{span:'8', offset: '1'}" :xs="{span:'24'}" class="auth-holder"  >
        <!-- <el-card v-loading="loading" class="box-card" style="margin-top: 20px;"> -->
          <h1>Register <img :src="image_brand" class="image-brand" /></h1>
          <el-alert
            v-if="error"
            :title="error"
            type="error"
            center
            :closable="false"
            show-icon>
          </el-alert>
          <el-form class="auth-form" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" size="small" label-position="top" hide-required-asterisk >
            <el-form-item label="Email" prop="email" :error="errorForm.email">
              <el-input v-model="ruleForm.email" @keyup.enter.native="submitForm('ruleForm')"></el-input>
            </el-form-item>
            <el-form-item label="Password" prop="password" :error="errorForm.password">
              <el-input type="password" v-model="ruleForm.password" show-password @keyup.enter.native="submitForm('ruleForm')"></el-input>
            </el-form-item>
            <el-form-item label="Ulang Password" prop="ulang_password" :error="errorForm.ulang_password">
              <el-input type="password" v-model="ruleForm.ulang_password" show-password @keyup.enter.native="submitForm('ruleForm')"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm')" :loading="loading">Daftar</el-button>
            </el-form-item>
          </el-form>
          sudah punya akun? masuk <router-link :to="{name: 'login'}" style="text-decoration:none;">disini</router-link>
        <!-- </el-card> -->
      </el-col>
    </el-row>
  <!-- </el-container> -->
</template>

<script>
import {auth} from '../../firebase'

export default {
  data() {
    return {
      ruleForm: {
        email: '',
        password: '',
        ulang_password: '',
      },
      error: '',
      rules: {
        email: [
          { required: true, message: 'Masukkan email', trigger: 'blur' },
          { type: 'email', message: 'Email tidak valid', trigger: 'blur' },
        ],
        password: [
          { required: true, message: 'Masukkan password', trigger: 'blur' }
        ],
        ulang_password: [
          { required: true, message: 'Ulangi password', trigger: 'blur' }
        ]
      },
      errorForm: {
        email: '',
        password: '',
        ulang_password: ''
      },
      loading: false,
      image_brand: require('../../assets/logo-putih.png'),
      image_auth: require('../../assets/background-auth.png'),
    }
  },
  methods: {
    submitForm: function (formName) {
      this.loading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.password != this.ruleForm.ulang_password) {
            this.error = 'Password tidak sama'
            this.loading = false
          } else {
            auth.createUserWithEmailAndPassword(this.ruleForm.email, this.ruleForm.password)
              .then((doc) => {
                this.loading = false
                localStorage.first_open = true
                this.$store.commit("setUser", doc.user)
                this.$router.go({name: 'kata-pengantar'})
              })
              .catch((error) => {
                this.loading = false
                switch(error.code) {
                  case 'auth/invalid-email':
                    this.error = 'Format email salah'
                    break;
                  case 'auth/weak-password':
                    this.error = 'Password minimal 6 karakter'
                    break;
                  case 'auth/email-already-in-use':
                    this.error = 'Email telah terpakai'
                    break;
                  default: 
                    this.error = 'Terjadi kesalahan'
                }
              });
          }
        } else {
          this.loading = false
        }
      });
    }
  },
  mounted() {

  }
}
</script>
